'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isWhiteLabel = exports.getWhiteLabelSiteUrl = exports.getWhiteLabelSiteName = exports.getWhiteLabelSellerId = exports.getWhiteLabelName = exports.getWhiteLabelLogo = exports.getHostName = undefined;
exports.default = reducer;

var _reselect = require('reselect');

// reducer
var DEFAULT_STATE = {
    hostname: '',
    isWhiteLabel: false,
    logo: '',
    sellerId: 0,
    siteName: '',
    siteUrl: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.whiteLabel;
};

var getHostName = exports.getHostName = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state ? state.hostname : '';
});

var getWhiteLabelLogo = exports.getWhiteLabelLogo = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.logo;
});
var getWhiteLabelName = exports.getWhiteLabelName = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.name;
});
var getWhiteLabelSellerId = exports.getWhiteLabelSellerId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.sellerId;
});
var getWhiteLabelSiteName = exports.getWhiteLabelSiteName = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.siteName;
});
var getWhiteLabelSiteUrl = exports.getWhiteLabelSiteUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    if (!state.siteUrl.includes('http')) {
        return '//' + state.siteUrl;
    }
    return state.siteUrl;
});
var isWhiteLabel = exports.isWhiteLabel = (0, _reselect.createSelector)(stateSelector, function (state) {
    return Boolean(state.isWhiteLabel);
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/whiteLabel.js
// module id = cYj3
// module chunks = 60